import React, { FC, useEffect, useState } from 'react';
import classes from './SignUpView.module.scss'; // reuse same styles
import CircleLoader from './CircleLoader';
import Button from './Button';
import axiosClient from '../service/axiosClient';
import { history } from '../reducers/store';
import { useParams } from 'react-router-dom';

const ActivateView: FC = () => {
  const { code } = useParams<{ code: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    axiosClient
      .get(`user/activate/${code}`)
      .then((res) => {
        setMessage(res.data.message || 'Account activated!');
        setStatus('success');
      })
      .catch((err) => {
        setMessage(err?.response?.data?.message || 'Activation failed. The link may have expired.');
        setStatus('error');
      });
  }, [code]);

  return (
    <div className={classes.mainCont}>
      <div className={classes.bg}></div>
      <div className={classes.panel}>
        <div className={classes.header}>
          <div className={classes.title}>Account activation</div>
        </div>
        <div className={classes.body}>
          {status === 'loading' && <CircleLoader size={20} />}
          {status !== 'loading' && (
            <>
              <p style={{ textAlign: 'center' }}>{message}</p>
              <Button onClick={() => history.push('/login')}>
                {status === 'success' ? 'Log in now' : 'Back to login'}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivateView;
